exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vue-form-generator .field-switch .label {\n  background: #4DBD74\n}\n", ""]);

// exports
